// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
    import RaisedButton from 'material-ui/RaisedButton';
  
  
  class FoodRental extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        data_uploaded: false,
        data_error: false,
        mobile_no: '',
        payment_modes: [],  
        equipment_details: {
            food_and_beverage:0,
            epigamia_yogurt:0,
            customer_id: '',
            payment_mode: '',
            amount: 0,
        }, 
        cust_details:{
          customer_id:'',
          mobile_no: '',
          name: '',
        },
        search:false,
        customer_search_list: [],
        dialog_open_cust:true,
        amount:0,
        dialog:false,
      };
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.searchCustomer = this.searchCustomer.bind(this);
      this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
      this.handleCustChange = this.handleCustChange.bind(this);
    }
  
    componentDidMount() {
        this.paymentModes();
    }

    handlecustClose = () => {
      this.setState({dialog_open_cust:false});
    };

    handleOpen=()=>{
      this.setState({dialog_open_cust:true})
    }    

    paymentModes(){
      const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({payment_modes:data.payment_modes});
           // alert("fix");
       }).catch(error => error);
    }


    searchCustomer() {
      {this.state.cust_details.mobile_no?this.getSearchList(this.state.cust_details.mobile_no):
        alert('Search cannot be blank')}
    }
    
    getSearchList(mobile_no) {
      const url = `${getLocationOrigin()}/eagleeye/search/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                           'search': mobile_no
                         });
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({customer_search_list: data.results, search: true}))
         .catch(error => {
           console.log(error);
           alert(error.message);
         });
    }    

    handleCustomerSubmit(){
      console.log('post');
        
      const url = `${getLocationOrigin()}/eagleeye/add_new_customer/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'customer_name': this.state.cust_details.name,
                          'customer_mobile': this.state.cust_details.mobile_no,
                        });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .catch(error => {
          console.log(error);
          alert(error.message);
        })
        .then(data => {
          if(data.success){
            var cust = Object.assign([], this.state.equipment_details);
            cust.push({'id': data.customer.id});
            this.setState({customer_search_list: cust});
            alert(data.message);
            this.handleClose();
          } else {
            alert(data.message);
          }
         });
    }

    postUpdateBooking(data, details, amount,props) {
        console.log(data);
        const url = `${getLocationOrigin()}/eagleeye/update_court_booking/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                          'food_and_beverage': details.food_and_beverage,
                                            'epigamia_yogurt': details.epigamia_yogurt,
                                            'customer_id': details.customer_id,
                                            'amount':amount,
                                            'payment_mode': details.payment_mode
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(function(response){                     
              alert(response.message);
              props.history.goBack();
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }


    getAmount(data){
        if(data.no_of_racket && data.no_of_hours && data.no_of_shoes && data.no_of_shuttle){
        const url = `${getLocationOrigin()}/eagleeye/get_booking_subscription_amount/?no_of_racket=${data.no_of_racket}&&no_of_hours=${data.no_of_hours}&&no_of_shoe=${data.no_of_shoes}&&no_of_shuttle=${data.no_of_shuttle}`;
        const options = {...defaultOptions};

        console.log('Going to fetch')
        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => this.setState({ amount: data.amount}))
        .catch(error => error);
        }
    }

    handleChange(event) {
        const name = event.target.name;
        var new_value =  Object.assign({}, this.state.equipment_details);
        new_value[name] = event.target.value
        this.setState({equipment_details: new_value});
        // this.getAmount(this.state.equipment_details)
    }

    handleSubmit(event) {
        console.log('handle')
        event.preventDefault();
        console.log('Submit');
        this.postUpdateBooking(this.state.court_booking_id, this.state.equipment_details ,this.state.amount, this.props)
      }

    setSearch(name, mobile_no,  customer_id){
      var new_selected_one =  Object.assign({}, this.state.equipment_details);
      new_selected_one['customer_id'] = customer_id

      var cust_change = Object.assign({}, this.state.cust_details);
      cust_change['customer_id'] = customer_id
      cust_change['mobile_no'] = mobile_no
      cust_change['name'] = name
      this.setState({equipment_details: new_selected_one, cust_details: cust_change, search: false});
    }

    handleCustChange(event){
      const name = event.target.name;
      var cust_details = Object.assign({}, this.state.cust_details);
        cust_details[name] = event.target.value;
      this.setState({cust_details: cust_details});
    }

  
    render() {
        console.log('amount')
        console.log(this.state.equipment_details);
      const actionscust = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handlecustClose}
        />,
        <FlatButton
          label="Submit"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];  
      return(
        <div style={styles.container}>
          <div className="row col-md-9 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12">
              <h3 style={{textAlign:'center'}}> F & B Rental</h3>
            </div>
            <form  className="validated-form form-horizontal">

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Qunatity of F&B
                </div>
                <input type="number" style={styles.input} className="required" name="food_and_beverage" value={this.state.equipment_details.food_and_beverage}
                onChange={this.handleChange} />
              </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Quantity of Epigamia Yogurt
                </div>
                <input type="number" style={styles.input} className="required" name="epigamia_yogurt" value={this.state.equipment_details.epigamia_yogurt}
                onChange={this.handleChange} />
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Item Amount
              </div>
              <input type="number" style={styles.input} className="required" name="amount" value={this.state.amount}
              onChange={(event)=>{this.setState({amount:event.target.value})}}/>
            </div>

            <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Payment Modes
                  </div>
                 <select name="payment_mode" className="col-md-6" style={styles.item_body} value={this.state.value}
                   onChange={this.handleChange}>
                    {
                       Object.keys(this.state.payment_modes).map((key, index) => (
                       <option key={key} value={key}>{`${this.state.payment_modes[key]}`}</option>
                       ))
                     }
              </select>
              </div>
            <div style={styles.items} className="col-md-12">
             <div style={{fontSize: '120%',fontWeight: 600,paddingLeft: '6%',}} className="col-md-6">
                  Customer No
                </div>
                <div className="col-md-6 input-group">
                  <input type="text" name="mobile_no" className="form-control"
                    placeholder="Search for.. " value={this.state.cust_details.mobile_no +this.state.cust_details.name} onChange={this.handleCustChange}/>
                  <span className="input-group-btn">
                    <button className="btn btn-default glyphicon glyphicon-search"
                    type="button" onClick={this.searchCustomer}></button>
                  </span>
                </div>
                {this.state.search?
              <div className="col-md-12 btn-group">
                {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.mobile_no, x.id, )}>{x.name}:{x.mobile_no}</button>))
            :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
            <div className="alert alert-danger">Search customer not found</div>
            <div>
                <RaisedButton
                  onClick={this.handleOpen}
                  label="Add"
                  style={{float:'right'}}
                  secondary={true}
                />
                <Dialog
                  actions={actionscust}
                  modal={false}
                  open={this.state.dialog_open_cust}
                  onRequestClose={this.handlecustClose}
                >
                  <div>
                      <div style={styles.main_header} className="col-md-12">
                          <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                        </div>
                            <div style={styles.items} className="col-md-12">
                              <div style={styles.item_header} className="col-md-6">
                                Name
                              </div>
                              <input type="text" style={styles.input} name="name" className="required"
                                value={this.state.value} onChange={this.handleCustChange}/>
                            </div>

                            <div style={styles.items} className="col-md-12">
                              <div style={{fontSize: '120%',fontWeight: 600,paddingLeft: '11%',}} className="col-md-6">
                                Mobile No
                              </div>
                            <input type="number" style={styles.input} name="mobile_no" className="required"
                              value={this.state.cust_details.mobile_no} onChange={this.handleCustChange}/>
                          </div>
                        </div>
                      </Dialog>
                    </div>
                    </div>
                }</div>:''

              }
              </div>
            <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
              <div style={styles.button_submit} className="col-md-12">
                <input className="btn btn-lg" type="submit" value="Update Booking" onClick={this.handleSubmit} style={{backgroundColor:'#302C35',
                  color:'#ffffff'}}/>
              </div>
              </div>
              
          </form>
          </div>
        </div>
      );
    }
  }
  
  export default FoodRental;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/foodRental/index.js